<template>
  <div>
    <div class="head-box">
      <h4>{{ templateTypeTitle }}</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入标题"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click.native="doNew">新建</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          empty-text="暂无数据"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column
            fixed="right"
            width="100px"
            v-if="permissions.isEdit || permissions.isDel"
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="permissions.isEdit" @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native.prevent="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native.prevent="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item> -->
                  <el-dropdown-item
                    v-if="permissions.isDel"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column label="标题" width="250px" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click.native.prevent="handleRowClick(scope.row)" type="text">
                {{ scope.row.title }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="formDefId"
            label="关联表单"
            :formatter="formatFormDefId"
            width="150px"
          ></el-table-column>
          <el-table-column
            prop="state"
            label="状态"
            width="80px"
            :formatter="formatState"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
          <el-table-column prop="content" label="描述" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :title="`${templateTypeTitle}定义`" :visible.sync="openDetail" width="700px">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="90px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="formData.content"></el-input>
        </el-form-item>
        <el-form-item label="关联表单">
          <el-select v-model="formData.formDefId" clearable filterable>
            <el-option
              v-for="item in options.formDefId"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="前前置脚本">
          <el-input type="textarea" :rows="3" v-model="formData.def.prePreActionScript"></el-input>
        </el-form-item>
        <el-form-item label="取消工作流的动作脚本">
          <el-input type="textarea" :rows="3" v-model="formData.cancelScript"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  activated() {
    window.$this = this;
  },
  name: 'workflows',
  data() {
    return {
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        def: {}
      },
      rules: this.$util.rules,
      tenantId: '',
      options: {
        codecfg_formDefId: { codeId: 'formDefId' }
      },
      //类型
      templateType: '',
      //标题
      templateTypeTitle: '',
      //权限
      permissions: {}
    };
  },
  mounted() {
    window.$this = this;
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.getForms();
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    formatFormDefId(row, column, cellValue) {
      return this.osg.codelabel('formDefId', cellValue);
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doEnable(id) {
      this.osg.ajax('workflowDef/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('workflowDef/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doInit() {
      this.openDetail = false;
      this.formData = { def: {} };
      this.templateType = this.osg.param('templateType');
      switch (
        this.templateType //1,4,5在ext
      ) {
        case 'TT2':
          this.templateTypeTitle = '业务流程';
          this.permissions.isAdd = false;
          this.permissions.isEdit = true;
          this.permissions.isDel = false;
          break;
        case 'TT3':
          this.templateTypeTitle = '工作流程';
          this.permissions.isAdd = true;
          this.permissions.isEdit = true;
          this.permissions.isDel = false;
          break;
        case 'TT5':
          this.templateTypeTitle = '审批流程';
          this.permissions.isAdd = true;
          this.permissions.isEdit = true;
          this.permissions.isDel = false;
          break;
        default:
          this.templateTypeTitle = '工作流列表';
          this.permissions.isAdd = false;
          this.permissions.isEdit = false;
          this.permissions.isDel = false;
      }
      if (this.$refs.formData) this.$refs.formData.resetFields();
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:title|string#or': this.searchValue,
        'is:templateType|string#and': this.templateType,
        'in:state|array-integer#and': '0,1'
      };
      this.osg.setFpi(params);
      this.osg.ajax('workflowDef/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        this.formData.tenantId = this.formData.tenantId || this.tenantId;
        var params = {};
        this.formData.templateType = this.templateType;
        params.workflowDef = JSON.stringify(this.formData);
        this.osg.ajax('workflowDef/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('workflowDef/remove/' + id + '.do', null, res => {
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    getForms() {
      this.osg.ajax('biz/ext/query.do', { _all: '1', 'is:state|integer#and': 1 }, res => {
        res.data.map(item => {
          item.label = item.title;
          item.value = item._id;
        });
        this.options.formDefId = res.data;
        this.osg.getFpi();
        this.getData();
      });
    },
    // $router.push({ path: `/workflow/${scope.row._id}` })
    handleRowClick(row) {
      this.$router.push({
        path: `/workflow/${row._id}`
      });
      this.SetCachedViews({
        params: row.title,
        action: `/workflow/${row._id}`
      });
    }
  }
  // watch: {
  //   $route() {
  //     this.doInit();
  //     this.getForms();
  //   }
  // }
};
</script>
